import { render } from "./ModalSettings.vue?vue&type=template&id=2e71ad5a"
import script from "./ModalSettings.vue?vue&type=script&lang=js"
export * from "./ModalSettings.vue?vue&type=script&lang=js"

import "./ModalSettings.vue?vue&type=style&index=0&id=2e71ad5a&lang=css"
script.render = render

export default script